










import { Component, Vue } from 'vue-property-decorator';
import { InvestmentEntity } from 'types/investment-entity';
import NavInvestmentEntityListItem from '@components/header/navigation/nav-investment-entity-list-item.vue';
import { user } from '@store/modules/user';

@Component({
	components: {
		NavInvestmentEntityListItem
	}
})
export default class NavInvestmentEntityList extends Vue {
	get investmentEntities(): Array<InvestmentEntity> {
		if (user.user) {
			return user.user.entityDetails.investmentEntities;
		}

		return [];
	}
}
